/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../dataQueryExecution/api/QueryModifierAPI',
	'./api/SummaryQueryModifierAPI',
	'underscore'
], (APIFactory, QueryModifierAPI, SummaryQueryModifierAPI , _) => {

	class SummaryQueryModifier {
		constructor(options) {
			const features = options && options.features;
			if (features) {
				this._mainModifier = features.QueryModifier;
			}

			const queryExecution = features && features.DataQueryExecution;
			if (queryExecution) {
				queryExecution.registerQueryModifier(this.getAPI());
			}
			this._dataItemLists = [];
		}

		getAPI() {
			if (!this.api) {
				this.api = APIFactory.createAPI(this, [
					QueryModifierAPI,
					SummaryQueryModifierAPI
				]);
			}
			return this.api;
		}

		getType() {
			return 'summary';
		}

		resetDataItemIdList() {
			this._dataItemLists = [];
		}

		addDataItemIdList(dataItemList) {
			this._dataItemLists.push(dataItemList);
		}

		/**
		 * Modify query spec based on the data item list added from SummaryTask in order.
		 */
		modifyQuerySpecList(specList) {
			specList = this._mainModifier && this._mainModifier.modifyQuerySpecList(specList);
			let extraFiltersRequired = [];
			const dataItemList = this._dataItemLists.shift();
			specList.forEach(specEntry => {
				specEntry.spec.dataItems = _.filter(specEntry.spec.dataItems, dataItem => {
					if (dataItemList.indexOf(dataItem.id) < 0) {
						// if the dataItem is not projected, but the dataItem affects the shape of the data result, e.g topbottom,
						// keep the dataItem in the list AND add a filter entry.
						let extraFilter = this._getSummaryExtraFilter(dataItem);
						if (extraFilter) {
							extraFiltersRequired.push(extraFilter);
							return true;
						}
						// otherwise remove it from the summary query
						return false;
					}
					// keep it as part of the summary query
					return true;
				});
				specEntry.spec.projections = _.filter(specEntry.spec.projections, projection => dataItemList.indexOf(projection) > -1);
				if (extraFiltersRequired.length) {
					const addExtraFilters = (specFilters, extraFilters) => {
						specFilters.push(...extraFilters);
						return specFilters;
					};
					specEntry.spec.filters = specEntry.spec.filters ? addExtraFilters(specEntry.spec.filters, extraFiltersRequired) : extraFiltersRequired;
				}

			});
			return specList;
		}

		/**
		 * @private
		 * Get the extra filter required for non-projected dataitems in a summary query
		 * @param {object} dataItem - dataItem
		 * @return {object} filter entry representing the non-projected data item context, null if an extra filter is not required
		 */
		_getSummaryExtraFilter(dataItem) {
			let extraFilter = null;
			_.each(dataItem.selection, (select) => {
				if (select.operation !== 'order') {
					extraFilter = {
						type: 'pre',
						expression: {
							operator: 'in',
							itemId: dataItem.itemId,
							valueDataItem: dataItem.id
						}
					};
				}
			});
			return extraFilter;
		}
	}
	return SummaryQueryModifier;
});
